import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Baseurl } from '../constants/env';
import axios from 'axios'

const Forgotpassword = () => {
      const [email,setEmail] = useState();
    async function Data(e){
        e.preventDefault();
        console.log(email, 'ff');
        
    //     let data = {
    //       username:Username,
    //       password:Password
    //     }
    //    await axios.post(`${Baseurl}/login`,data ,{ withCredentials: true }).then(async (resp)=>{

    //     }).catch((err)=>{
    //     console.log(err);
    //     // enqueueSnackbar('Error '+ err.response.data.message,{variant:'warning'})
    
    //    });
     }
  return (
    <div>
      
<main className="main">
<section class="section-contact-us">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  Login
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="contact-form register-form text-center">
              <h3 class="mb-0">Welcome back!</h3>
              <p>Enter your details below.</p>

              <form>
              <div class="mb-3">
                   <input  value={email} onChange={(e)=>{setEmail(e.target.value)}} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Email" />
              </div>

                <button type="submit" onClick={Data} class="btn btn-primary-theme d-block w-100 mb-4">
                  Submit
                </button>

                <p>Don’t have an account? <Link to="/register">Register now! </Link> </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
</main>
    </div>
  )
}

export default Forgotpassword
